/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Platform, Animated, StyleProp, ViewStyle, StyleSheet, View, TextStyle } from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  Text as SVG_Text,
  TSpan as SVG_TSpan,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const TSpan = Animated.createAnimatedComponent(SVG_TSpan);
const Text = Animated.createAnimatedComponent(SVG_Text);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
import FontList from "react-native-font-list";
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="150" height="40" viewBox="0 0 150 40" fill="none"> <desc id="IMP.BLUE">{"#Rectangle_2051":{"type":"SELECTOR","constraint":"none","width":150,"height":40},"#export":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":62,"height":24},"#UploadIcon":{"type":"SELECTOR","constraint":"xMinYMid meet","width":16,"height":16},"#Vector":{"type":"SELECTOR","constraint":"none","width":16,"height":16},"transforms":{"UploadIcon":[{"name":"UploadIcon","relativeTransforms":[[1,0,26],[0,1,11]],"rotation":0,"instanceParentName":"UploadIcon","isInstanceParent":true,"isInstanceChild":false,"width":16,"height":16}],"Vector":[{"name":"Vector","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"UploadIcon","isInstanceParent":false,"isInstanceChild":true,"width":16,"height":16}]},"tProps":{"type":"PROPS","ExportButton?":"tButtonProps","onAnimationComplete?":"() => void"},"#ExportButton":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.ExportButton?.onPress","animation":"touchableOpacity"},"constraint":"none","width":150,"height":40}}</desc>
 * <g id="ExportButton">
 * <rect id="Rectangle 51" width="150" height="40" rx="2" fill="#2C4B46"/>
 * <text id="export" fill="white" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14" font-weight="600" letter-spacing="0.06em"><tspan x="84" y="0.441998">    </tspan><tspan x="54.6793" y="25.442">EXPORT</tspan></text>
 * <g id="UploadIcon">
 * <path id="Vector" d="M40 22V25H28V22H26V25C26 26.1 26.9 27 28 27H40C41.1 27 42 26.1 42 25V22H40ZM29 16L30.41 17.41L33 14.83V23H35V14.83L37.59 17.41L39 16L34 11L29 16Z" fill="white"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Rectangle_2051": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 150,
 * 		"height": 40
 * 	},
 * 	"#export": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 62,
 * 		"height": 24
 * 	},
 * 	"#UploadIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMid meet",
 * 		"width": 16,
 * 		"height": 16
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 16,
 * 		"height": 16
 * 	},
 * 	"transforms": {
 * 		"UploadIcon": [
 * 			{
 * 				"name": "UploadIcon",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						26
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						11
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "UploadIcon",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 16,
 * 				"height": 16
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "UploadIcon",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 16,
 * 				"height": 16
 * 			}
 * 		]
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"ExportButton?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#ExportButton": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.ExportButton?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 150,
 * 		"height": 40
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  ExportButton?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const ExportButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  ExportButton?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 150,
      height: 40,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    ExportButtonButtonOpacity: number;
  }>({
    ExportButtonButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region ExportButton Button Handlers

  const { ExportButton = {} } = props;
  const { onPress: ExportButtonOnPress, ...ExportButtonProps } = ExportButton as tButtonProps;

  const ExportButtonButtonPressInFunction = () => 0;

  const ExportButtonButtonPressOutFunction = ExportButtonOnPress;

  const ExportButtonButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ExportButtonButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const ExportButtonButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ExportButtonButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const ExportButtonOnPressIn = () => {
    ExportButtonButtonActive(ExportButtonButtonPressInFunction);
  };

  const ExportButtonOnPressOut = () => {
    ExportButtonButtonInactive(ExportButtonButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} style={svgStyle}>
          <G
            id="ExportButton"
            opacity={buttonState.ExportButtonButtonOpacity}
            onMouseDown={ExportButtonOnPressIn}
            onMouseUp={ExportButtonOnPressOut}
            cursor="pointer"
            {...ExportButtonProps}
          >
            <Svg preserveAspectRatio="none" viewBox="0 0 150 40">
              <Path
                id="Rectangle_2051"
                fill="#2C4B46"
                d="M2 0 H148 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMaxYMid meet" viewBox="0 0 150 40">
              <Text
                id="export"
                fill="white"
                fontSize={14}
                fontWeight={600}
                letterSpacing="0.06em"
                fontFamily={checkFont("Raleway")}
              >
                <TSpan x={84} y={0.441998} id="export_elem0" />
                <TSpan x={54.6793} y={25.442} id="export_elem1">
                  {"EXPORT"}
                </TSpan>
              </Text>
            </Svg>
            <Svg preserveAspectRatio="xMinYMid meet" viewBox="0 0 150 40">
              <G id="UploadIcon">
                <Svg preserveAspectRatio="none" viewBox="0 0 150 40">
                  <Path
                    id="Vector"
                    d="M40 22V25H28V22H26V25C26 26.1 26.9 27 28 27H40C41.1 27 42 26.1 42 25V22H40ZM29 16L30.41 17.41L33 14.83V23H35V14.83L37.59 17.41L39 16L34 11L29 16Z"
                    fill="white"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 150 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Rectangle_2051"
          fill="#2C4B46"
          d="M2 0 H148 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMaxYMid meet"
        viewBox="0 0 150 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="export"
          fill="white"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0.06em"
          fontFamily={checkFont("Raleway")}
        >
          <TSpan x={84} y={0.441998} id="export_elem0" />
          <TSpan x={54.6793} y={25.442} id="export_elem1">
            {"EXPORT"}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMid meet"
        viewBox="0 0 150 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="UploadIcon">
          <Path
            id="Vector"
            d="M40 22V25H28V22H26V25C26 26.1 26.9 27 28 27H40C41.1 27 42 26.1 42 25V22H40ZM29 16L30.41 17.41L33 14.83V23H35V14.83L37.59 17.41L39 16L34 11L29 16Z"
            fill="white"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(ExportButton);
